import React, {useRef, useEffect, useState} from "react";
import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import mapboxgl from 'mapbox-gl'
import Slider from "react-slick";

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import Search from "../../components/Search";
import {useModal} from "../../components/ModalContext";
import TypingEffect from "../../components/TypingEffect/TypingEffect";
import MediaArticles from "../../components/MediaArticles/MediaArticles";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Modal, ProgressBar} from "react-bootstrap";
import './MushroomGwowth.scss';
import Alert from "react-bootstrap/Alert";

let img_top = require("../../assets/mushroom/30.png");

let background = require("../../assets/mushroom/bg.png");

function MushroomGrowth() {
    const [isLoading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [list, setList] = useState([]);
    const [lastUpdate, setLastUpdate] = useState(null);

    useEffect(() => {
        fetch(global.route.permission, {
            method: "post", credentials: 'include'
        }).then(response => {
            if (response.status === 200) {
                response.json().then(response => {
                    setUser(response.user);
                });
            }
        });
        fetch(global.route.areaListLevel, {
            method: "post",
            credentials: 'include',
            body: global.getFormData({type: "TYPE_MUSHROOM"})
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        let list = response.list;
                        list = list.sort((a, b) => b.area_level - a.area_level);
                        console.log("list");
                        console.log(list);
                        setList(list);
                        setLastUpdate(response.last_update);
                        setLoading(false);
                    })
                }
            });

    }, []);

    let getLastUpdate = () => {
        if (isLoading)
            return;
        if (lastUpdate === null)
            return "Nessun dato disponibile";
        else return "Ultimo aggiornamento: " + lastUpdate;
    }


    let getTable = () => {
        // console.log("listttt");
        // console.log(list);
        if (isLoading)
            return;
        if (Object.keys(list).length === 0)
            return <Alert key={"danger"} variant={"danger"}>Nessun dato disponibile</Alert>;

        // console.log("listttt");
        // console.log(list);

        let result = [];
        // for(let item of list) {
        //     console.log("item");
        //     console.log(item);
        // }
        result = list.map(item => {
            return <tr key={item.id}>
                <td>{item.region}</td>
                <td>{item.name}</td>
                <td>
                    {item.area_level === null ? (
                        "non disponibile"
                    ) : (
                        getProgress(item.area_level)
                    )}
                </td>
                <td>
                    <Button href={`/events/${item.id}`} className="btn-orange">
                        Acquista ticket
                    </Button>
                </td>
            </tr>
        })


        return <table>
            <caption>Tabella crescite funghi</caption>
            <thead>
            <tr>
                <th>Regione</th>
                <th>Area</th>
                <th>Crescita</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {result}
            </tbody>
        </table>


    }

    let getProgress = (lv) => {
        switch (lv) {
            case 0:
                return <ProgressBar variant="progress-16" now={16} label={"Assente"}/>
            case 1:
                return <ProgressBar variant="progress-32" now={32} label={"Insufficiente"}/>

            case 2:
                return <ProgressBar variant="progress-48" now={48} label={"Scarsa"}/>
            case 3:
                return <ProgressBar variant="progress-64" now={64} label={"Buona"}/>

            case 4:
                return <ProgressBar variant="progress-80" now={80} label={"Abbondante"}/>

            case 5:
                return <ProgressBar variant="progress-100" now={100} label={"Miracolosa"}/>
        }

    }

    return (
        <div style={{backgroundColor: "#fafafa"}}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>

                <div className="overlay-content background">
                    <div>

                        <div style={{flex: 1}}>
                            <h1 className="title">Benvenuto nella<br/>
                                <b>Tabella Crescite Ordinaria</b></h1>
                        </div>
                        <h4>Ogni giorno raccogliamo con cura i dati forniti da enti e consorzi ufficiali,
                            e li trasformiamo in una bussola, per orientarti nel cuore del bosco.</h4>
                    </div>
                </div>
            </div>
            <div className={"container container-growth"} style={{backgroundImage: `url(${background})`}}>
                <div className="row">
                    <div className="col-md-6">
                        <h3>Scopri dove <b>stanno nascendo.</b></h3>
                        <span className={"orange"}>La tabella riporta le indicazioni degli Enti Ufficiali in merito alla crescita locale.</span>
                        <p>Geoticket ti riporta, gratuitamente, i dati indicati, in modo che tu sappia sempre dove
                            stanno
                            nascendo.</p>
                    </div>
                    <div className="col-md-6">
                        <div className={"legend"}>
                            <b>Legenda</b>
                            {getProgress(0)}
                            {getProgress(1)}
                            {getProgress(2)}
                            {getProgress(3)}
                            {getProgress(4)}
                            {getProgress(5)}
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="d-flex justify-content-center"><small>{getLastUpdate()}</small></div>
                {getTable()}

            </div>


            <Footer/>
        </div>
    );
}

export default MushroomGrowth;